import React, { useState } from 'react'
import { motion, useInView, useAnimation } from "framer-motion"
import { useEffect, useRef } from 'react'
import "./about.css"

import styledSectionBreak from '../assets/lineBreak.svg'
import profilePicture from "../assets/profilePicture.png"


const About = (props) => {

  const openLightbox = props.openLightbox

  // Light box
  const openLightbox0 = () =>
  {
    openLightbox("About", 0)
  }

  // Motion Animations
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true })
  const motionControls = useAnimation()

  useEffect(() =>
  {
    if(isInView)
    {
      motionControls.start("visible")
    }
  }, [isInView])

  return (
    <section ref={ref} className="about section" id='about'>
        <motion.h2 
          className="section__title about__title"
          variants={{
            hidden: { opacity: 0, y: 1 },
            visible: { opacity: 1, y: 0 }
          }}
          initial='hidden'
          animate={motionControls}
          transition={{
            duration: 0.5,
            delay: 0.5
          }}
        >About</motion.h2>
        <span className="section__subtitle about__subtitle"><img src={styledSectionBreak} className='styledLineBreak' alt="" /></span>

        <div className="about__container container grid">
            <img src={profilePicture} alt="profile-picture" className="about__img" />
            
            <div className="about__data">

              <p className="about__description">
              Dr. Sasha Chaddah has provided aesthetic treatments in London, ON, since 2003. She has partnered with <a href="https://redefinemd.com" target='_blank'>RedefineMD</a>, a boutique clinic in London, that offers patients a variety of non-invasive cosmetic procedures. Her approach to facial rejuvenation focuses on understanding your concerns and goals, and providing customized treatments that achieve a balanced, natural appearance in harmony with your unique facial proportions. 
              <br />
                <br />
                She views education, compassion and collaboration as key elements in helping patients achieve the positive aging outcomes they desire.

                <br />
                <a href="#0" className="about__more" onClick={openLightbox0}> Read more...  &nbsp;&nbsp;&nbsp;</a>
              </p>

            </div>
        </div>
    </section>
  )
}

export default About
